export const FILTER_CONNEXIONS_FORM = 'FILTER_CONNEXIONS_FORM'
export const CONNEXIONS_TABLE_NAME = 'SuiviConnexions'